import { useMutation } from '@tanstack/react-query';
import { engineeringOperationsApi } from '../../apis';
import { InternalApiSetFinalRiskRangesRequest } from '../../api-internal';

export const useSetFinalRiskRanges = () =>
  useMutation({
    mutationFn: (request: InternalApiSetFinalRiskRangesRequest) =>
      engineeringOperationsApi.setFinalRiskRanges({ internalApiSetFinalRiskRangesRequest: request }),
  });
